/**
 * USB Truth Card — bascule recto/verso (clic, Entrée, Espace).
 * reduced-motion : flip via classe seule (CSS masque/affiche).
 */
(function () {
  'use strict';

  function initCard(card) {
    if (!card || card.dataset.usbTruthReady) return;
    card.dataset.usbTruthReady = '1';

    function toggle() {
      var flipped = card.classList.toggle('is-flipped');
      card.setAttribute('aria-pressed', flipped ? 'true' : 'false');
      var root = card.closest('.canicule-usb-truth');
      var live = root ? root.querySelector('[data-usb-truth-live]') : null;
      if (live) {
        live.textContent = flipped
          ? live.getAttribute('data-msg-back') || ''
          : live.getAttribute('data-msg-front') || '';
      }
    }

    card.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-usb-truth-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
